import {
  VALIDATION_ERROR_INVALID_EMAIL,
  VALIDATION_ERROR_INVALID_PASSWORD
} from './messages';

// See https://stackoverflow.com/a/1373724 or https://tools.ietf.org/html/rfc2822#section-3.4.1
const EMAIL_FORMAT_RFC_2822 = /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/i;

export const emailRequired = value =>
  value ? undefined : VALIDATION_ERROR_INVALID_EMAIL;

export const passwordRequired = value =>
  value ? undefined : VALIDATION_ERROR_INVALID_PASSWORD;

export const required = value => (value ? undefined : 'Required');

export const number = value =>
  value && isNaN(Number(value)) ? 'Must be a number' : undefined;

export const email = value =>
  value && !EMAIL_FORMAT_RFC_2822.test(value)
    ? 'Invalid email address'
    : undefined;

export const alphaNumeric = value =>
  value && /[^a-zA-Z0-9 ]/i.test(value)
    ? 'Only alphanumeric characters'
    : undefined;

export const phoneNumber = value =>
  value && !/^(0|[1-9][0-9]{9})$/i.test(value)
    ? 'Invalid phone number, must be 10 digits'
    : undefined;

// Factory functions for validators.
export const createMaxLength = max => value =>
  value && value.length > max ? `Must be ${max} characters or less` : undefined;

export const createMinLength = min => value =>
  value && value.length < min ? `Must be ${min} characters or more` : undefined;

export const createMinValue = min => value =>
  value && value < min ? `Must be at least ${min}` : undefined;

export default {
  required,
  number,
  email,
  alphaNumeric,
  phoneNumber,
  emailRequired,
  passwordRequired
};



// WEBPACK FOOTER //
// ./src/utils/fieldValidators.js